import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { CountdownTimer } from './CountdownTimer';
import { trackAddToCart } from '../utils/metaPixel';
export function PricingSection() {
  const [viewers, setViewers] = useState(47);
  useEffect(() => {
    const interval = setInterval(() => {
      // Random fluctuation between 38 and 67
      const newViewers = Math.floor(Math.random() * (67 - 38 + 1)) + 38;
      setViewers(newViewers);
    }, 5000);
    return () => clearInterval(interval);
  }, []);
  const includes = [{
    text: 'Fábrica de Contenido con IA — 8 Módulos completos',
    check: '✓',
    color: 'text-green'
  }, {
    text: 'El Método R.I.C.E. + Plantillas maestras',
    check: '✓',
    color: 'text-green'
  }, {
    text: 'El Workflow de 4 Horas paso a paso',
    check: '✓',
    color: 'text-green'
  }, {
    text: 'Sistema de Creación en Lote (Canva)',
    check: '✓',
    color: 'text-green'
  }, {
    text: 'Framework de Multiplicación Omnicanal',
    check: '✓',
    color: 'text-green'
  }, {
    text: 'BONO: La Librería de Oro — 50 Prompts Maestros',
    check: '★',
    color: 'text-gold',
    bold: true
  }, {
    text: 'Descarga instantánea en PDF',
    check: '✓',
    color: 'text-green'
  }, {
    text: 'Acceso de por vida + Actualizaciones',
    check: '✓',
    color: 'text-green'
  }];
  return <section id="precio" className="py-28 px-6 bg-dark text-center" data-id="element-234">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-100px'
    }} className="mb-12" data-id="element-235">
        <span className="inline-block text-orange text-xs font-bold tracking-[2px] uppercase mb-4" data-id="element-236">
          Inversión
        </span>
        <h2 className="text-[clamp(28px,4vw,48px)] font-black mb-10 text-white" data-id="element-237">
          Todo incluido.
          <br data-id="element-238" />
          Una sola inversión.
        </h2>

        <div className="max-w-[600px] mx-auto mb-10" data-id="element-239">
          <div className="inline-flex items-center gap-2 bg-red-500/10 border border-red-500/30 text-red-500 px-4 py-1.5 rounded-full text-sm font-bold mb-6" data-id="element-240">
            <span className="relative flex h-2.5 w-2.5" data-id="element-241">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-red-400 opacity-75" data-id="element-242"></span>
              <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-red-500" data-id="element-243"></span>
            </span>
            🔥 OFERTA POR TIEMPO LIMITADO
          </div>
          <CountdownTimer compact={false} data-id="element-244" />
          <p className="text-[#AAAAAA] text-sm mt-6" data-id="element-245">
            Cuando el timer llegue a 0, el precio sube a $47
          </p>
        </div>
      </motion.div>

      <motion.div initial={{
      opacity: 0,
      scale: 0.95
    }} whileInView={{
      opacity: 1,
      scale: 1
    }} viewport={{
      once: true,
      margin: '-100px'
    }} className="max-w-[520px] mx-auto bg-cardBg border-2 border-orange rounded-[24px] p-10 md:p-12 relative overflow-hidden" data-id="element-246">
        <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-orange to-gold" data-id="element-247" />

        <div className="absolute top-5 -right-[30px] bg-gold text-dark px-10 py-1.5 font-black text-[12px] rotate-45 tracking-[1px]" data-id="element-248">
          MÁS POPULAR
        </div>

        <p className="text-[18px] text-[#888] line-through mb-2" data-id="element-249">
          Valor real: $47
        </p>

        <div className="flex items-end justify-center gap-2 mb-2" data-id="element-250">
          <span className="text-[28px] font-bold text-orange pb-2" data-id="element-251">$</span>
          <span className="text-[80px] font-black text-white leading-none" data-id="element-252">
            9
          </span>
          <span className="text-[28px] font-bold text-white pb-2" data-id="element-253">.99</span>
        </div>

        <div className="inline-block bg-[rgba(0,210,106,0.15)] border border-[rgba(0,210,106,0.3)] text-green px-4 py-1.5 rounded-full text-[14px] font-semibold mb-6" data-id="element-254">
          ✓ Ahorras $37 hoy
        </div>

        <div className="flex flex-col items-center gap-2 mb-8" data-id="element-255">
          <div className="text-[13px] text-[#AAAAAA] flex items-center gap-1.5 bg-white/5 px-3 py-1 rounded-full" data-id="element-256">
            <span className="animate-pulse" data-id="element-257">👀</span> {viewers} personas viendo
            esta página ahora
          </div>
          <div className="text-[12px] font-bold text-red-400 bg-red-500/10 px-3 py-1 rounded-full border border-red-500/20" data-id="element-258">
            ⚡ Solo quedan 23 copias a este precio
          </div>
        </div>

        <div className="text-left mb-8 flex flex-col gap-3" data-id="element-259">
          {includes.map((item, i) => <div key={i} className="flex items-center gap-3 text-[15px] text-[#CCCCCC]" data-id="element-260">
              <span className={`${item.color} text-[18px] shrink-0`} data-id="element-261">
                {item.check}
              </span>
              <span className={item.bold ? 'font-bold text-white' : ''} data-id="element-262">
                {item.text}
              </span>
            </div>)}
        </div>

        <hr className="border-t border-border my-6" data-id="element-263" />

        <a href="https://www.viventispace.com/cart/46018757623996:1" target="_blank" rel="noopener noreferrer" onClick={() => trackAddToCart()} className="bg-gradient-to-br from-orange to-[#FF8C00] text-white px-12 py-[18px] rounded-xl font-extrabold text-lg no-underline block transition-all duration-300 shadow-[0_8px_32px_rgba(255,107,0,0.4)] hover:-translate-y-[3px] hover:shadow-[0_12px_40px_rgba(255,107,0,0.6)] w-full text-center animate-pulse" data-id="element-264">
          🏭 Quiero Mi Fábrica Ahora →
        </a>

        <p className="text-[13px] text-gray-400 mt-5" data-id="element-265">
          <span className="text-green" data-id="element-266">✓ Descarga instantánea</span>{' '}
          &nbsp;•&nbsp; Pago seguro &nbsp;•&nbsp; Sin suscripción
        </p>
      </motion.div>
    </section>;
}